export default __webpack_public_path__ + "static/media/pen.650f2f1a.svg";